import * as React from 'react';
import GridContainer from "../GenericComponents/Grids/GridContainer";
import {createBreadCrumbBasedOnPage} from "../../Utils/HelperFunctions";
import * as actionTypes from "../../store/action";
import {connect} from "react-redux";

interface NtcUpgradeInfoProps {
    setBreadCrumbPath: (breadCrumbPath:BreadCrumb[]) => void;
}

interface NtcUpgradeInfoState {
}

class NtcUpgradeInfo extends React.Component<NtcUpgradeInfoProps,NtcUpgradeInfoState> {

    constructor(props: NtcUpgradeInfoProps) {
        super(props);
    }

    componentDidMount(): void {
        this.props.setBreadCrumbPath(createBreadCrumbBasedOnPage(window.location.pathname.split('/').filter(x => x)));
    }

    render() {
        return (
            <GridContainer
                getGridDataUrl={'/api/auth/viewGridData/ntcUpgradeInfo'}
                addRecordUrl={'/api/auth/saveGridRecord/ntcUpgradeInfo'}
                editRecordUrl={'/api/auth/editGridRecord/ntcUpgradeInfo'}
                deleteRecordUrl={'/api/auth/removeGridRecord/ntcUpgradeInfo'}
                gridPaginated={true}
                formEditing={true}
                showUtilityColumns={true}
                exportLink={'viewGridData/ntcUpgradeInfo'}
                gridTitle={'View NTC Upgrade Info'}
                gridId={'ntcUpgradeInfoGrid'}
                typeForSuperClass={'ntcUpgradeInfo'}
            />
        );
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        setBreadCrumbPath: (breadCrumbPath:BreadCrumb[]) => dispatch(
            {type: actionTypes.SET_BREADCRUMB_PATH, payload: breadCrumbPath})
    }
};

export default connect(null, mapDispatchToProps)(NtcUpgradeInfo);